export default __webpack_public_path__ + "d6e3f02f21be00366101d4dc3985cc43.svg";